"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var adapter_1 = require("./adapter");
var errors_1 = require("./errors");
var adapter_2 = require("./adapter");
exports.ResponseStatus = adapter_2.ResponseStatus;
exports.SlackMessageAdapter = adapter_2.SlackMessageAdapter;
var errors_2 = require("./errors");
exports.ErrorCode = errors_2.ErrorCode;
/**
 * Dictionary of error codes that may appear on errors emitted from this package's objects
 */
exports.errorCodes = {
    BODY_PARSER_NOT_PERMITTED: errors_1.ErrorCode.BodyParserNotPermitted,
};
// TODO: export other error codes
/**
 * Factory method to create an instance of {@link SlackMessageAdapter}
 */
function createMessageAdapter(signingSecret, options) {
    return new adapter_1.SlackMessageAdapter(signingSecret, options);
}
exports.createMessageAdapter = createMessageAdapter;
//# sourceMappingURL=index.js.map